import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { getAssetUrl } from '../../utils/assetUrl'
import { UserData } from '../GlobalHeader'
import { FramedAvatar } from './FramedAvatar'

const imgFallback = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const { currentTarget } = e
    currentTarget.onerror = null // prevents looping
    currentTarget.src = getAssetUrl('/flags/WORLD@2x.png')
}

export const MiniProfile: FC<{
    userData: UserData
    size?: 'small' | 'large'
}> = ({ userData, size = 'large' }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: size === 'large' ? 'center' : 'flex-start',
                px: size === 'large' ? 2 : 1.6,
                pb: 2,
            }}
        >
            <Box display="flex" flexDirection="column" gap={0.5}>
                <Typography color="primary.main" fontWeight={700} variant="body1" fontSize="18px" textTransform="none">
                    {userData.user_name}
                </Typography>
                <Box sx={{ height: size === 'large' ? '30px' : '18px', display: 'flex', gap: 1, alignItems: 'center' }}>
                    <img
                        src={getAssetUrl(`/flags/${userData.country || 'WORLD'}@2x.png`)}
                        onError={imgFallback}
                        alt={'flag icon'}
                        style={{ height: '100%', borderRadius: size === 'large' ? '6px' : '3px' }}
                    />
                    {userData.title && (
                        <Box
                            sx={{
                                p: '8px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                border: '2px solid',
                                borderRadius: size === 'large' ? '6px' : '4px',
                            }}
                        >
                            <Typography variant={'h6'} textTransform="uppercase">
                                {userData.title?.split(',')[0]}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
            <FramedAvatar
                avatar={userData?.avatar_url || ''}
                season={userData?.reward?.season}
                reward={userData?.reward?.tier}
                sx={{
                    height: size === 'large' ? '50px' : '36px',
                    width: size === 'large' ? '50px' : '36px',
                }}
            />
        </Box>
    )
}
